import {
  PushDestinationType,
  PushStatus,
  PushTargetType,
  PushType,
} from 'types';

/** 백엔드 push-message.constants.ts 와 같은 값 */
export const PUSH_TITLE_MAX_LENGTH = 20;
export const PUSH_BODY_MAX_LENGTH = 50;

export const PUSH_TYPE_LABEL: Record<PushType, string> = {
  NOTICE: '공지',
  PROMOTION: '홍보',
};

export const PUSH_STATUS_LABEL: Record<PushStatus, string> = {
  DRAFT: '작성 중',
  SCHEDULED: '예약',
  SENDING: '발송 중',
  SENT: '발송 완료',
  FAILED: '발송 실패',
  CANCELED: '예약 취소',
};

export const PUSH_DESTINATION_LABEL: Record<PushDestinationType, string> = {
  TAB_HOME: '홈',
  TAB_EVENT: '봉켓팅',
  TAB_TALK: '공지방',
  TAB_MY: 'MY',
  MESSAGE: '메시지함',
  ENROLL_LIST: '신청 내역',
  EVENT_DETAIL: '특정 봉사',
  CONTENTS: '컨텐츠',
  EVENT_FEEDBACK: '봉사 피드백',
};

/** 피드백은 시스템 자동 발송이라 제외 */
export const ADMIN_SELECTABLE_DESTINATIONS = (
  Object.keys(PUSH_DESTINATION_LABEL) as PushDestinationType[]
).filter((type) => type !== 'EVENT_FEEDBACK');

/** 연결 대상(destinationDetail)을 입력받아야 하는 화면 */
export const DESTINATIONS_WITH_DETAIL: PushDestinationType[] = [
  'EVENT_DETAIL',
  'CONTENTS',
  'EVENT_FEEDBACK',
];

export const PUSH_TYPE_OPTIONS = (
  Object.keys(PUSH_TYPE_LABEL) as PushType[]
).map((value) => ({ value, name: PUSH_TYPE_LABEL[value] }));

export const PUSH_TARGET_OPTIONS: { value: PushTargetType; name: string }[] = [
  { value: 'ALL', name: '전체 회원' },
  { value: 'INDIVIDUAL', name: '회원 선택' },
];

export const PUSH_STATUS_OPTIONS = (
  Object.keys(PUSH_STATUS_LABEL) as PushStatus[]
).map((value) => ({ value, name: PUSH_STATUS_LABEL[value] }));

export const PUSH_DESTINATION_OPTIONS = ADMIN_SELECTABLE_DESTINATIONS.map(
  (value) => ({ value, name: PUSH_DESTINATION_LABEL[value] }),
);

/** 참여자 알림 모달은 피드백까지 포함 */
export const DIRECT_PUSH_DESTINATION_OPTIONS = (
  Object.keys(PUSH_DESTINATION_LABEL) as PushDestinationType[]
).map((value) => ({ value, name: PUSH_DESTINATION_LABEL[value] }));

/** 예약 분 단위. 백엔드 폴링 주기와 맞춘다. */
export const SCHEDULE_MINUTE_UNIT = (() => {
  const parsed = Number(process.env.REACT_APP_PUSH_SCHEDULE_MINUTE_UNIT);
  return Number.isFinite(parsed) && parsed > 0 ? parsed : 5;
})();

/** 발송 후에는 수정·취소할 수 없다. */
export const isEditable = (status: PushStatus) =>
  status === 'DRAFT' || status === 'SCHEDULED';

export const formatRate = (rate: number | null) =>
  rate === null ? '-' : `${(rate * 100).toFixed(1)}%`;
